import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { LottieAnimationComponent } from '../../shared/components/lottie-animation/lottie-animation.component';

@Component({
  selector: 'app-thank-you',
  standalone: true,
  imports: [CommonModule, LottieAnimationComponent],
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {
  source: string | null = null;

  
  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      this.source = params.get('source');
      if (this.source) {
        // can use this.source for display or analytics here
        console.log('Lead source:', this.source);
      }
    });
  }

}
